/* eslint-disable max-len */
import React from 'react'
import ANCHORS from 'root/src/shared/constants/anchors'
import Link from 'root/src/client/web/base/Link'
import { CREATOR_DATA_AUDIO_ALERTS_OUTPUT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { daysToExpire } from 'root/src/shared/constants/timeConstants'

export default [
	{
		sectionTitle: 'For Fans',
		id: ANCHORS.FANS,
		items: [
			{
				title: 'What is Dare Drop?',
				id: ANCHORS.WHAT_IS_FANS,
				content: (
					<p>
						Dare Drop is a place where you can challenge your favorite
						creators to do something awesome, funny, or difficult. It’s
						like donations, but you can issue challenges or requests.
					</p>
				),
			},
			{
				title: 'What happens if my Dare is accepted?',
				id: ANCHORS.FANS_ACCEPTED,
				content: (
					<p>
						If a creator has accepted your Dare that means they will be
						taking on the challenge. You will not be charged until the
						Dare has been confirmed complete.
					</p>
				),
			},
			{
				title: 'What happens if my Dare was completed?',
				id: ANCHORS.FANS_COMPLETED,
				content: (
					<p>
						Once your Dare was completed by the creator, they will upload
						it to Dare Drop. Dare Drop will send you a notification and
						save the clip so you can watch it at any time.
					</p>
				),
			},
			{
				title: 'What happens if my Dare wasn’t accepted or the creator failed to complete my Dare?',
				id: ANCHORS.FANS_NOT_COMPLETED,
				content: (
					<p>
						In either case, the Dare will expire and you will not be charged.
					</p>
				),
			},
			{
				title: 'My favorite creator doesn’t have Dare Drop. What should I do?',
				id: ANCHORS.FAN_NO_CREATOR,
				content: (
					<p>Let them know you’ve made a Dare for them in chat or on
						social media. You can tag us of course. If you let us know,
						we’ll be happy to reach out to the creator as well.
					</p>
				),
			},
			{
				title: 'How much of each bounty does the creator get?',
				id: ANCHORS.FAN_CREATOR_CUT,
				content: (
					<p>
						At Dare Drop, our goal is help creators turn their passion
						into their career. We take a 10% fee, and transaction costs on Dares
						and this is only charged once the Dare is successfully
						completed.
					</p>
				),
			},
		],
	},
	{
		sectionTitle: 'For Creators',
		id: ANCHORS.CREATORS,
		items: [
			{
				title: 'What is Dare Drop?',
				id: ANCHORS.CREATOR_WHAT_IS,
				content: (
					<p>
						Dare Drop is a way to create exciting and engaging content with
						your top fans and earn money for doing it. Fans will create
						Dares which are challenges or requests in exchange for money.
						As a creator you can get more of your audience involved to
						crowdfund those Dares too. Once you’ve accepted and
						completed a Dare you will get paid.
					</p>
				),
			},
			{
				title: 'How do I join Dare Drop?',
				id: ANCHORS.CREATOR_JOIN,
				content: (
					<p>
						Simple! Create an account and authenticate through Twitch to
						show us who you are. From there you can accept Dares from your
						fans or even create your own and see if they will fund it.
					</p>
				),
			},
			{
				title: 'Now that I’ve made an account on Dare Drop, what’s next?',
				id: ANCHORS.CREATOR_WHATS_NEXT,
				content: (
					<p>
						Add our panel to your Twitch description and Nightbot. Also,
						make some starter Dares and let your viewers know how Dare Drop
						works!
					</p>
				),
			},
			{
				title: 'I’ve completed a Dare. Now what? ',
				id: ANCHORS.CREATOR_COMPLETED,
				content: (
					<p>
						Click on the dare, click the deliver button, and add a
						time-stamped highlight, a clip, or a YouTube link where your
						pledgers can watch it.
					</p>
				),
			},
			{
				title: 'How do I get paid?',
				id: ANCHORS.HOW_PAID,
				content: (
					<p>
						We pay via PayPal once you have completed the Dare. Make sure
						you’ve added your payout email in account settings. The payment
						will arrive 2 days after your video is approved. Bits payments
						happen as normal through Twitch.
					</p>
				),
			},
			{
				title: 'How does Dare Drop make money?',
				id: ANCHORS.DD_FEE,
				content: (
					<p>
						To help creators continue doing what they love, Dare Drop
						takes a small fee of 10% for every completed Dare.
					</p>
				),
			},
			{
				title: 'How do I accept and reject Dares?',
				id: ANCHORS.CREATOR_ACCEPT_REJECT,
				content: (
					<p>
						To accept or reject a Dare click on the Dare that you’d like to
						take action on and do it right from the Dare itself. If you
						have yet to authenticate your Twitch you will need to do that
						first so we can verify you are the creator.
					</p>
				),
			},
			{
				title: 'How do I set a goal for my Dare?',
				id: ANCHORS.SET_GOAL,
				content: (
					<p>
						Once you have accepted the Dare you are given the option to set
						a goal. This means you can set your price and crowdfund any
						accepted Dares.
					</p>
				),
			},
			{
				title: 'How long do I have to complete a Dare?',
				id: ANCHORS.HOW_LONG,
				content: (
					<p>
						Dares are live for {daysToExpire} days from their creation date.
					</p>
				),
			},
			{
				title: 'How do I ensure profane or inappropriate content does not appear on my page?',
				id: ANCHORS.CREATOR_MODERATE,
				content: (
					<p>
						Dare Drop auto-filters content that is offensive - but since our filter isnt
						perfect, creators can also reject dares from the twitch panel or website,
						which will remove them entirely.
					</p>
				),
			},
			{
				title: 'If my funding goal isn’t achieved, can I still deliver the dare?',
				id: ANCHORS.CREATOR_UNDER_GOAL,
				content: (
					<p>
						Yes. You can deliver any time & you’ll recieve the amount that has been pledged
						once your video is approved.
					</p>
				),
			},
			{
				title: 'Do I have to complete the Dare while live streaming?',
				id: ANCHORS.MUST_STREAM,
				content: (
					<p>
						Not at all! As long as you have a Twitch, YouTube, or Facebook clip of you
						completing the Dare, we’ll approve it.
					</p>
				),
			},
			{
				title: 'Can I use audio alerts with StreamLabs OBS or other software?',
				id: ANCHORS.BROADCASTING_SOFTWARE,
				content: (
					<p>
						Yes - any broadcasting software that supports a browser source will work.
						That includes StreamLabs OBS, OBS, Twitch Studios, Xsplit, and GameShow.
						Let us know if you have questions about your software.
					</p>
				),
			},
			{
				title: 'My audio alerts aren’t working. What can I do?',
				id: ANCHORS.AUDIO_TROUBLESHOOTING,
				content: (
					<p>
						Refresh the cache on your browser source. If that doesn’t fix it, go to
						OBS Settings =&gt; Advanced and try enabling or disabling &quot;Browser Source
						Hardware Acceleration.&quot; Use your test audio buttons at
						<Link routeId={CREATOR_DATA_AUDIO_ALERTS_OUTPUT_ROUTE_ID}> daredrop.com/alerts</Link>.
					</p>
				),
			},
		],
	},
	{
		sectionTitle: 'Drops',
		id: ANCHORS.DROPS,
		items: [
			{
				title: 'What are drops?',
				id: ANCHORS.DROPS_WHAT,
				content: (
					<p>
						Drops are bounties created by video game publishers where creators can win rewards for fans.
					</p>
				),
			},
			{
				title: 'What do I need to participate in drops?',
				id: ANCHORS.DROPS_PARTICIPATE,
				content: (
					<p>
						Create your account with Dare Drop and verify by authenticating with Twitch, YouTube or TikTok.
						To participate in drops you must be consistently creating content on your channel with
						at least 5 CCV on Twitch or 100 average views on YouTube.
					</p>
				),
			},
			{
				title: 'Do I have to buy the game before I can do drops?',
				id: ANCHORS.BUY_GAME,
				content: (
					<p>
						Nope! Once you accept your first drop you’ll receive an email from us with your key if the
						game isn’t free to play. Game publishers often also include helpful information about
						their game or anything else you might need to get started in that email.
					</p>
				),
			},
			{
				title: 'How many drops can I do?',
				id: ANCHORS.DROPS_HOW_MANY,
				content: (
					<p>
						You can complete all of the drops listed on each event page! Accept any/all drops that you think
						you can complete and take on the challenge! Side scroll to see all the drops in the event.
						There are usually 10+.
					</p>
				),
			},
			{
				title: 'I accepted this drop but can’t access it.',
				id: ANCHORS.CANT_ACCESS,
				content: (
					<p>
						You can access all of your dares by going to “My Profile” in the menu at the top right
						corner of the page.
					</p>
				),
			},
			{
				title: 'How do I complete a drop?',
				id: ANCHORS.DROP_COMPLETE,
				content: (
					<p>
						Once you complete the drop on your channel make sure you upload a twitch clip/highlight,
						or time stamped YouTube video to the specific drop on Dare Drop. Once uploaded we’ll
						verify your reward in less than 24 hours.
						The easiest way to do that is head back to daredrop.com and click on “My Profile” in the
						drop down menu at the top right.
					</p>
				),
			},
			{
				title: 'How do I access my rewards?',
				id: ANCHORS.DROP_REWARDS,
				content: (
					<p>
						Once you complete a drop and it’s verified you will receive an email from Dare Drop
						with your rewards.
					</p>
				),
			},
			{
				title: 'Is this offer available in all regions?',
				id: ANCHORS.DROP_REGIONS,
				content: (
					<p>
						Most drops are available in all regions - but contact us at support@daredrop.com if
						you encounter an issue.
					</p>
				),
			},
		],
	},
	{
		sectionTitle: 'For Brands',
		id: ANCHORS.BRANDS,
		items: [
			{
				title: 'How do brands use Dare Drop?',
				id: ANCHORS.BRANDS_USE,
				content: (
					<p>
						Brands make creators Dares, or sponsor fan-made Dares and can
						request to include a short sponsor messaging in the Dare if
						desired. Dares might be specific gameplay, a shout out, or a
						funny request.
					</p>
				),
			},
			{
				title: 'What type of brands are on Dare Drop?',
				id: ANCHORS.BRANDS_TYPE,
				content: (
					<p>
						Dare Drop is used by any brand interested in connecting with
						gamers! Whether you are a game developer looking to engage with
						your community, or an energy drink offering a promotion you
						can make highly engaging Dares for creators.
					</p>
				),
			},
			{
				title: 'How does it work?',
				id: ANCHORS.BRANDS_HOW,
				content: (
					<p>
						Create Dares for creators by choosing a game, dare/challenge,
						and the amount you will compensate the creator for completing
						the Dare. After the creator uploads a clip of the Dare, the
						Brand gets to approve the video before processing payment.
					</p>
				),
			},
			{
				title: 'Why Dare Drop?',
				id: ANCHORS.BRANDS_WHY,
				content: (
					<p>
						Dare Drop is a highly engaging and interactive way to engage
						with creators and their audiences. Instead of the typical
						‘brought to you by’ messaging in many on-demand activations, we
						offer something for the fans.
					</p>
				),
			},
			{
				title: 'How does billing work?',
				id: ANCHORS.BRANDS_BILLING,
				content: (
					<p>
						For self-service, Dare Drop billing works exactly the same for
						everyone. Once you’ve approved the Dare, payment is sent via
						PayPal who takes out their fees. Other than that, 90% goes to
						the creator and 10% goes to Dare Drop.
						For managed service, see the next question!
					</p>
				),
			},
			{
				title: 'Does Dare Drop offer managed services?',
				id: ANCHORS.BRANDS_MANAGED,
				content: (
					<p>
						Yes! Dare Drop has a team that can manage a complete influencer
						marketing campaign on Dare Drop from start to finish. This
						includes curation, management, and reporting. Please inquire at
						support@daredrop.com for more information.
					</p>
				),
			},
		],
	},
]
